/**
 * Whether the in-app login page is available.
 * Injected at build time via webpack (REACT_APP_ENABLE_LOGIN).
 */
export function isLoginEnabled() {
    return process.env.REACT_APP_ENABLE_LOGIN === "true";
}
